import deepmerge from 'deepmerge';
import { AbstractFacade, DefaultExposeGroupEnum, plainToInstanceWithLVS } from '@goparrot/common';
import { SearchItemResultDto, SyncJobResponseDto } from '../dto';
export class ItemFacade extends AbstractFacade {
    constructor(config = {}, interceptors) {
        super(deepmerge({
            axiosConfig: {
                baseURL: process.env.GOPARROT_PLATFORM_SERVICE_MENU_SYNC,
            },
        }, config), interceptors);
    }
    async search(merchantId, storeId, query, type) {
        const requestConfig = { params: { query, type } };
        return plainToInstanceWithLVS(SearchItemResultDto, (await this.client.get(`api/v2/merchants/${encodeURIComponent(merchantId)}/stores/${encodeURIComponent(storeId)}/items/search`, requestConfig)).data, { groups: [DefaultExposeGroupEnum.READ] });
    }
    async registerSyncJob(merchantId, storeId, type, uniqueName, options = {}) {
        const requestConfig = { params: options };
        return plainToInstanceWithLVS(SyncJobResponseDto, (await this.client.post(`api/v2/merchants/${encodeURIComponent(merchantId)}/stores/${encodeURIComponent(storeId)}/items/${encodeURIComponent(type)}/${encodeURIComponent(uniqueName)}/sync-jobs`, requestConfig)).data, { groups: [DefaultExposeGroupEnum.READ] });
    }
}
//# sourceMappingURL=ItemFacade.js.map